<template>
  <a :href="uri" target="_blank" :title="title" class="image__pinterestLink">
    <slot>
      <img
        src="/typo3conf/ext/template/Resources/Public/Media/Social-media/icon_pinterest_f_white.svg"
        width="50"
        height="50"
        alt="pinterest logo"
      >
    </slot>
  </a>
</template>

<script>
  export default {
    name: 'pinterest-button',
    props: {
      uri: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        default: '',
      },
    },
  };
</script>
